<template>
  <div
    v-if="isOpen && resourcesList.length"
    id="task_resources_preview"
    :class="$style.task_resources_preview_popup"
  >
    <vgp-scroll-bar
      :class="$style.task_resources_list"
    >
      <div
        v-for="item in filteredResources"
        :key="item.resource_id"
        :class="$style.task_resource_item"
      >
        <div
          v-if="item.isDivider"
          :class="$style.divider_item_container"
        >
          <span :class="$style.divider_caption">
            {{ locales(item.label) }}
          </span>

          <span :class="$style.divider_underline" />
        </div>

        <div
          v-else
          :class="$style.resource_item_container"
        >
          <div :class="$style.info_box">
            <vgp-avatar
              :class="$style.resource_item_icon"
              :src="item.picture"
              custom-size="22"
            />

            <div :class="$style.resource_item_info">
              {{ formatName(item.name) }}
            </div>
          </div>

          <div
            v-if="!item.hideValuesInTemplates"
            :class="$style.resource_input_container"
          >
            <span :class="$style.label_box">{{ item.value }}</span>

            <span :class="$style.label_box">{{ locales(getLabelValueByResourceType(item.type)) }}</span>
          </div>
        </div>
      </div>
    </vgp-scroll-bar>
    <div :class="['js_preview_popup_bottom_arrow', $style.preview_popup_bottom_arrow]" />
  </div>
</template>

<script>
import _ from 'lodash';
import app from '$$app';
import vgpAvatar from '$$vueCmp/avatar/vgpAvatar.vue';
import vgpScrollBar from '$$vueCmp//scrollBar/vgpScrollBar.vue';
import constants from '$$helpers/constants';
import taskResourcesHelpers from './helpers';

export default {
  name: 'TaskResourcesPreviewPopup',
  components: { vgpAvatar, vgpScrollBar },
  data() {
    return {
      locales: __,
      isOpen: false,
      timer: null,
      eventsListeners: [],
      resourcesList: [],
    };
  },
  computed: {
    filteredResources() {
      const resourcesList = this.resourcesList;

      const groupedResources = _.groupBy(resourcesList, resource => (_.isNull(resource.userId) ? 'material' : 'people'));

      return [
        ...groupedResources.people ? [{ isDivider: true, label: 'resources_layout_header_title_1' }] : [],
        ...groupedResources.people || [],
        ...groupedResources.material ? [{ isDivider: true, label: 'resources_layout_header_title_2' }] : [],
        ...groupedResources.material || [],
      ];
    },
  },
  created() {
    this.addEventListeners();
  },
  beforeUnmount() {
    this.removeEventsListeners();
  },
  methods: {
    addEventListeners() {
      this.removeEventsListeners();

      this.eventsListeners.push(app.on('showResourcesPreviewListForTask', this.showResourcesPreviewListForTask.bind(this)));
      this.eventsListeners.push(app.on('hideResourcesPreviewListForTask', this.hideResourcesPreviewListForTask.bind(this)));
    },

    removeEventsListeners() {
      this.eventsListeners.forEach(id => app.off(id));
      this.eventsListeners = [];
    },

    showResourcesPreviewListForTask(position, taskId, ganttId) {
      this.hideResourcesPreviewListForTask();

      const component = this;

      this.timer = setTimeout(() => {
        component.resourcesList = taskResourcesHelpers.getResourcesListForPreview(taskId, ganttId);

        component.isOpen = true;
        component.$nextTick(() => {
          component.resourcesList.length && component.calcPopupPosition(position);
        });
      }, 1000);
    },

    hideResourcesPreviewListForTask() {
      clearTimeout(this.timer);

      this.isOpen = false;
    },

    calcPopupPosition(position) {
      const popup = document.querySelector('#task_resources_preview');
      const popupHeight = popup.clientHeight;
      const popupWidth = popup.clientWidth;
      const rightWidth = document.body.clientWidth - position.left;
      const bottomArrow = popup.querySelector('.js_preview_popup_bottom_arrow');

      const top = position.top > popupHeight
        ? position.top - popupHeight - 3
        : position.top + position.height;
      
      const left = rightWidth < popupWidth
        ? position.right - popupWidth
        : position.left;

      popup.style.left = `${left}px`;
      popup.style.top = `${top}px`;

      if (bottomArrow) {
        bottomArrow.style.left = `${position.left + 13}px`;
        bottomArrow.style.top = `${position.top > popupHeight
          ? top + popupHeight - (bottomArrow.clientHeight / 2)
          : top - (bottomArrow.clientHeight / 2)
        }px`;
      }
    },

    formatName(str) {
      return str.replace(/>/g, '&gt;').replace(/</g, '&lt;');
    },

    getLabelValueByResourceType(type) {
      switch (type) {
      case constants.RESOURCE_TIME_TYPE:
        return 'resource_time_type';
      case constants.RESOURCE_ITEM_TYPE:
        return 'resource_item_type';
      case constants.RESOURCE_COST_TYPE:
        return 'resource_cost_type';
      }
    },
  },
};
</script>

<style module src="./styles.less" lang="less"></style>
